import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';

import ApiService from '../../../service/ApiService';
import AddNewClient from './partials/AddNewClient';
import AddNewUser from './partials/AddNewUser';
import { Toast } from 'primereact/toast';

const ClientManager = (props) => {
    const [clients, setClients] = useState(null);
    const [addClientVisible, setAddClientVisible] = useState(null);
    const [editClientVisible, setEditClientVisible] = useState(null);
    const [editUserVisible, setEditUserVisible] = useState(null);
    const [currentEditId, setCurrentEditId] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [clientUsers, setClientUsers] = useState(null);
    const [addUserVisible, setAddUserVisible] = useState(false);
    const toast = useRef(null);

    useEffect(() => {
        const apiService = new ApiService();
        apiService.getAllClients().then((clients) => {
            setClients(clients);
        });
    }, []);

    useEffect(() => {
        if (selectedClient) {
            const apiService = new ApiService();
            apiService.getUsersByClient(selectedClient).then((users) => {
                setClientUsers(users);
            });
        }
    }, [selectedClient]);

    const editClient = (rowData) => {
        setCurrentEditId(rowData.id);
        setEditClientVisible(true);
    };

    const editData = (rowData) => {
        setCurrentEditId(rowData.id);
        setEditUserVisible(true);
    };

    const viewUsers = (clientId) => {
        setSelectedClient(clientId);
        const apiService = new ApiService();
        apiService.getUsersByClient(clientId).then((users) => {
            setClientUsers(users);
        });
    };



    const refreshPage = () => {
        const apiService = new ApiService();
        apiService.getAllClients().then((clients) => {
            setClients(clients);
        });
    };

    const backToClients = () => {
        setSelectedClient(null);
        setClientUsers(null);
    };

    const addUser = () => {
        setAddUserVisible(true);
    };

    const handleAddUser = async (userDetails) => {
        const apiService = new ApiService();
        const result = await apiService.addClientUser(userDetails);
        if (result.success) {
            toast.current.show({ severity: 'success', summary: 'User Added Successfully.', detail: '' });
            viewUsers(selectedClient);
        } else {
            toast.current.show({ severity: 'error', summary: 'User Addition Failed.', detail: result.message });
        }
        setAddUserVisible(false);
    };

    const handleEditUser = async (userDetails) => {
        const apiService = new ApiService();
        const result = await apiService.updateClientUser(userDetails);
        if (result.success) {
            toast.current.show({ severity: 'success', summary: 'User Updated Successfully.', detail: '' });
            viewUsers(selectedClient);
        } else {
            toast.current.show({ severity: 'error', summary: 'User Update Failed.', detail: result.message });
        }
        setEditUserVisible(false);
    };
    const handleDeleteUser = async (userId) => {
        confirmDialog({
            message: 'Are you sure you want to delete this user?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                const apiService = new ApiService();
                const result = await apiService.deleteUser(userId);
                if (result.succeeded) {
                    toast.current.show({ severity: 'success', summary: 'User Deleted Successfully.', detail: '' });
                    viewUsers(selectedClient);
                } else {
                    toast.current.show({ severity: 'error', summary: 'User Deletion Failed.', detail: result.message });
                }
            }
        });
    };
    const actionButtons = (rowData) => {
        return <div className="p-d-flex p-jc-between">
            <Button type="button" icon="pi pi-pencil" className="p-button p-button-outlined mr-3" onClick={() => editClient(rowData)} />
            <Button type="button" icon="pi pi-users" className="p-button p-button-outlined" onClick={() => viewUsers(rowData.id)} />
        </div>;
    };

    const userActionButtons = (rowData) => {
        return (
            <div className="p-d-flex p-jc-between">
                <Button type="button" icon="pi pi-times" className="p-button p-button-outlined p-button-danger mr-3" onClick={() => handleDeleteUser(rowData.id)} />
                <Button type="button" icon="pi pi-pencil" className="p-button p-button-outlined" onClick={() => editData(rowData)} />
            </div>
        );
    };

    const isAdminTemplate = (rowData) => {
        return rowData.privilegeLevel === 'GLOBAL_ADMIN' ? 'Yes' : 'No';
    };

    const userEnabledTemplate = (rowData) => {
        return rowData.enabled ? 'Yes' : 'No';
    };

    const dateCreatedTemplate = (rowData) => {
        return new Date(rowData.dateCreated).toLocaleString();
    };

    return (
        <>
            <Toast ref={toast} position="top-left" />
            <div className='col-12 mb-2'>
            {selectedClient && (
                            <Button label="Back to Clients" icon="pi pi-arrow-left" className="custombtn" onClick={backToClients} />
                        )}
            </div>
            <div className="col-12">
                <div className="grid p-fluid">
                    <div className="card">
                        <div className="header-card">
                            <h3>{selectedClient ? "Manage users" : "Manage clients"}</h3>

                            <div className="rhs-row-header">
                                {selectedClient && (
                                        <Button label="Add User" icon="pi pi-plus" className="custombtn" onClick={addUser} />
                               
                                )}
                                {!selectedClient && (
                                    <Button label="Add new client" icon="pi pi-plus" className="custombtn" onClick={() => setAddClientVisible(true)} />
                                )}
                                <Button label="Help" className="p-button-outlined" />
                            </div>
                        </div>
                        <div className="dataValuesTable">
                            <div className="col-1 col-offset-11">
                                <div className="grid p-fluid">
                                    <Button label="Refresh" className="p-button-outlined" icon="pi pi-refresh" onClick={(e) => refreshPage()} />
                                </div>
                            </div>
                            {!selectedClient && (
                                <DataTable value={clients} tableStyle={{ minWidth: '50rem', width: '100%' }}>
                                    <Column style={{ width: '150px' }} body={actionButtons}></Column>
                                    <Column field="organisationName" header="Organisation Name"></Column>
                                </DataTable>
                            )}
                            {selectedClient && (
                                <DataTable value={clientUsers} tableStyle={{ minWidth: '50rem', width: '100%' }}>     
                                    <Column style={{ width: '150px' }} body={userActionButtons}></Column>                               
                                    <Column field="firstName" header="First Name"></Column>
                                    <Column field="lastName" header="Last Name"></Column>
                                    <Column field="email" header="Email Address"></Column>
                                    <Column field="privilegeLevel" body={isAdminTemplate} header="Is Admin?"></Column>
                                    <Column field="enabled" body={userEnabledTemplate} header="Enabled"></Column>
                                    <Column field="dateCreated" body={dateCreatedTemplate} header="Created"></Column>
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog header="Add Client" visible={addClientVisible} style={{ width: '30vw', minWidth: '300px' }} onHide={() => setAddClientVisible(false)}>
                <AddNewClient refreshPage={refreshPage} setAddClientVisible={setAddClientVisible} toast={toast} />
            </Dialog>
            <Dialog header="Add User" visible={addUserVisible} style={{ width: '30vw', minWidth: '300px' }} onHide={() => setAddUserVisible(false)}>
                <AddNewUser handleAddUser={handleAddUser} clientId={selectedClient} />
            </Dialog>
            <Dialog header="Edit Client" visible={editClientVisible} style={{ width: '30vw', minWidth: '300px' }} onHide={() => setEditClientVisible(false)}>
                <AddNewClient edit={true} id={currentEditId} refreshPage={refreshPage} setAddClientVisible={setEditClientVisible} toast={toast} />
            </Dialog>
            <Dialog header="Edit User" visible={editUserVisible} style={{ width: '30vw', minWidth: '300px' }} onHide={() => setEditUserVisible(false)}>
                <AddNewUser handleAddUser={handleEditUser} userId={currentEditId} />
            </Dialog>
        </>
    );
}

export default ClientManager;